import React from 'react';
import { Typography } from '@mui/material';
import { text, textColors } from '../theme/typography';
import { withBrand } from './BrandName';

const Text = ({
  variant = 'body',
  color = 'primary',
  component,
  children,
  sx = {},
  brand = true,
  ...props
}) => {
  const resolvedColor =
    typeof color === 'string' && textColors[color] ? textColors[color] : color;

  const content =
    brand && typeof children === 'string' ? withBrand(children) : children;

  return (
    <Typography
      component={component}
      sx={{
        ...text[variant],
        color: resolvedColor,
        ...sx,
      }}
      {...props}
    >
      {content}
    </Typography>
  );
};

export default Text;
